import { MouseEvent } from 'react';

import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import EditIcon from '@mui/icons-material/Edit';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import IconButton from '@mui/material/IconButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import find from 'lodash-es/find';
import { bindMenu, bindTrigger, usePopupState } from 'material-ui-popup-state/hooks';
import { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';

import { LanguageKeys } from 'src/common/constants/languages';
import { TechnicalType } from 'src/interfaces/TechnicalType';
import { ITrackMap } from 'src/interfaces/TrackMap';
export function getTrackMapDistanceName(
  distanceId: string,
  currentLang: LanguageKeys,
  distances: TechnicalType[] | undefined,
  distancesById: Record<string, TechnicalType> | undefined,
): string {
  const distance =
    distancesById?.[distanceId] ?? (find(distances, d => d.id === distanceId) as TechnicalType | undefined);
  return distance?.i18n[currentLang] ?? '-';
}

export function formatTrackMapTime(time: number, t: TFunction): string {
  return t('timers.times.hour', { count: time });
}

export function formatTrackMapTotalDistance(totalDistance: number, t: TFunction): string {
  return t('system.trackMaps.totalDistance', { dist: totalDistance });
}

export function formatTrackMapLevelDiff(levelDiff: ITrackMap['levelDiff'], t: TFunction): string {
  return t('system.trackMaps.level', { pos: levelDiff.pos, neg: levelDiff.neg });
}

type TrackMapRowActionsProps = {
  trackMapId: string;
  onEdit: (e: MouseEvent<unknown>) => void;
  onDelete: (e: MouseEvent<unknown>) => void;
};

export function TrackMapRowActionsMenu({ trackMapId, onEdit, onDelete }: TrackMapRowActionsProps) {
  const { t } = useTranslation();
  const actionsMenu = usePopupState({ variant: 'popover', popupId: `track-map-actions-${trackMapId}` });

  return (
    <>
      <IconButton
        size="small"
        {...bindTrigger(actionsMenu)}
        aria-label={t('system.trackMaps.optionsLabel')}
      >
        <MoreVertIcon fontSize="small" />
      </IconButton>
      <Menu {...bindMenu(actionsMenu)}>
        <MenuItem
          onClick={e => {
            onEdit(e);
            actionsMenu.close();
          }}
        >
          <ListItemIcon>
            <EditIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>{t('system.trackMaps.editTrackMap')}</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={e => {
            onDelete(e);
            actionsMenu.close();
          }}
        >
          <ListItemIcon>
            <DeleteForeverIcon color="error" fontSize="small" />
          </ListItemIcon>
          <ListItemText>{t('system.trackMaps.deleteTrackMap')}</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
}
